import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";

import {
  MutationWithArrayInput,
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";

import { HRService, setupManagementUrl } from "../../../config";

import DynamicForm from "../../../data/Axios/DynamicForm";
import { imprestApllicationForSurrender, imprestApplications, imprestApplicationsByUser } from "../../../data/Queries/HRmanagement/leavemanagement";
import { imprestApplicationsForms } from "../../../data/DynamicTable/FormsFields/LeaveApplicationForms";
import { fetchJson } from "../../../data/DynamicServiceNew/jsondynamicservice";

const base_url = HRService.uri;

const ImprestSurrenderForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);
  const [imprestApplicationsData, setImprestApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  const initialValues = {
    applicationId: props.data ? props.data.ApplicationId : "",
    autoStaffClaim: props.data ? props.data.AutoStaffClaim : false,
    totalAmount: props.data ? props.data.TotalAmount : "",
    userId: userId,
    companyId: companyId,
  };

  async function fetchImprestApplications() {
    try {
      const data = await fetchJson({
       objectName: "imprestApplicationsForSurrender",
      baseUrl: base_url
    });
      if (data) {
        setImprestApplications(JSON.parse(data.results));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchImprestApplications();
  }, []);

  const imprestApplicationOptions = imprestApplicationsData
    ? imprestApplicationsData.map((app) => ({
        value: app.Id,
        label: app.Title,
      }))
    : [];

  const fields = [
    {
      name: "applicationId",
      label: "Imprest Application",
      type: "select",
      options: imprestApplicationOptions.map((app) => ({
        value: app.value,
        label: app.label,
      })),
      gridColumn: "span 2",
      required: true,
    },
    {
      name: "autoStaffClaim",
      label: "Auto Staff Claim",
      type: "checkbox",
      required: true,
      gridColumn: "span 2",
    },
  
  ];

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { applicationId, autoStaffClaim } = values;
      const mutationData = {

          applicationId,
          autoStaffClaim,
          
   
      };
      if (props.isEditing) {
        mutationData.id = props.data.id;
      }
      const response = await generateAndExecuteMutation(
        props.isEditing ? "updateImprestSurrender" : "createImprestSurrender",
        mutationData,
       'imprest',
        base_url
      );

    if (Object.values(response)[0]) {
      props.onClose();
      props.onAction();
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Imprest surrender created successfully.",
      });
    }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title={
        props.isEditing
          ? "Update Imprest Surrender"
          : "Create Imprest Surrender"
      }
      subtitle={
        props.isEditing
          ? "Fill out the form below to update imprest surrender."
          : "Fill out the form below to apply for imprest surrender."
      }
    />
  );
};

export default ImprestSurrenderForm;
